/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { ImmutableDenseMatrixDependencies } from './dependenciesImmutableDenseMatrixClass.generated';
import { createIndexClass } from '../../factoriesAny.js';
export var IndexDependencies = {
  ImmutableDenseMatrixDependencies: ImmutableDenseMatrixDependencies,
  createIndexClass: createIndexClass
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesIndexClass.generated.js
// module id = 46
// module chunks = 0